export const menuItems = [
  { title: 'میز کار', icon_url: '/svg/sidebar/dashboard-3-svgrepo-com.svg', link: '/' },
  { title: 'درخواست‌ها', icon_url: '/svg/ic-requests.9ced902.svg', link: '/requisitions' },
  { title: 'پیشنهادها', icon_url: '/svg/ic-offers.10c7849.svg', link: '/offers' },
  { title: 'سفارش‌ها', icon_url: '/svg/sidebar/order-svgrepo-com (1).svg', link: '/orders' },
  { title: 'خدمات', icon_url: '/svg/sidebar/service-setting-svgrepo-com.svg', link: '/services' },
  { title: 'تراکنش‌ها', icon_url: '/svg/ic-transactions.4ac8b16.svg', link: '/transactions' },
  { title: 'لیست کاربران', icon_url: '/svg/sidebar/users-svgrepo-com.svg', link: '/users' },
  { title: 'لیست لیدها', icon_url: '/svg/sidebar/ic-leads.svg', link: '/leaders' },
  { title: 'رشد', icon_url: '/svg/sidebar/growth-svgrepo-com.svg', link: '/growth' },
  { title: 'دسترسی‌ها', icon_url: '/svg/sidebar/security-s.svg', link: '/access' },
  { title: 'تنظیمات', icon_url: '/svg/sidebar/settings-svgrepo-com.svg', link: '/settings' },
  { title: 'بروزرسانی فنی', icon_url: '/svg/sidebar/version-history-svgrepo-com.svg', link: '/releases' },
]
